const windowHeight = window.innerHeight
document.documentElement.style.setProperty('--window-height', `${windowHeight}px`)
